import {Action} from "redux";
import {DateType, GeoState, OrderStatus, Origin, PaidStatus, PaymentGroup, PaymentMethod} from "./data";

export type OrdersFiltersAction = SetOrderStatusAction
	| SetPaidStatusAction
	| SetPaymentMethodAction
	| SetOriginAction
	| SetState
	| SetPaymentGroup
	| SetDateType
	| setFromDate
	| setToDate
	| clearFromDate
	| clearToDate

type SetOrderStatusAction = {
	type: 'set order status'
	orderStatus: OrderStatus
}

type SetPaidStatusAction = {
	type: 'set paid status'
	paidStatus: PaidStatus
}

type SetPaymentMethodAction = {
	type: 'set payment method'
	paymentMethod: PaymentMethod
}

type SetOriginAction = {
	type: 'set origin'
	origin: Origin
}

type SetState = {
	type: 'set state'
	state: GeoState
}

type SetPaymentGroup = {
	type: 'set payment group'
	paymentGroup: PaymentGroup
}

type SetDateType = {
	type: 'set date type'
	dateType: DateType
}

type setFromDate = {
	type: 'set from date'
	fromDate: Date
}

type setToDate = {
	type: 'set to date'
	toDate: Date
}

type clearFromDate = {
	type: 'clear from date'
}

type clearToDate = {
	type: 'clear to date'
}

export type OrdersFiltersActionWrapper = {
	type: 'orders filters action'
	action: OrdersFiltersAction
}

export const isOrdersFiltersAction = (a: Action): a is OrdersFiltersActionWrapper => {
	return a.type == "orders filters action"
}



// WEBPACK FOOTER //
// ./src/orders2/orders-filters/actions.ts